import { useMemo } from "react";
import { useFilters, usePagination, useSortBy, useTable } from "react-table";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

import { t } from "../../../services";
import { strCode } from "../../../consts";
import { useTableData } from "../../../hooks";

import {
  CircleIconButton,
  FlexContainers,
  Paragraph2,
  SVG,
  Table,
  WrapperContainer
} from "../../../components";
import { RolesTabTableColumns } from "./RolesTabTableColumns";
import { RoleTableWrapper } from "./styled";

const RolesTabTable = ({
  openModal,
  setRoleAdditionFlag,
  setRole,
  isReadOnlyAccess,
  isLoading
}) => {
  const selectedApp = useSelector((store) => store.apps.selectedApp);
  const error = useSelector((store) => store?.apps?.groupError);
  const defaultFeatures = useSelector((store) => store.apps.selectedApp.defaultSettings);

  const groupConfigsMapCallback = (groupConfig) => {
    const featuresNames = groupConfig?.features?.length
      ? groupConfig.features.map(
          (feature) => defaultFeatures.find((f) => f.code === feature)?.settingName || []
        )
      : [];

    return {
      ...groupConfig,
      features: featuresNames.join(", ")
    };
  };

  const appGroupConfigs = useTableData({
    loading: isLoading,
    data: selectedApp?.groupConfigs || [],
    loadingPlaceholdersRows: 5,
    mapCallback: groupConfigsMapCallback
  });

  const columns = useMemo(() => RolesTabTableColumns, []);

  const tableInstance = useTable(
    {
      columns,
      data: appGroupConfigs,
      initialState: {
        sortBy: [
          {
            id: "group",
            asc: true
          }
        ]
      }
    },
    useFilters,
    useSortBy,
    usePagination
  );
  const onSeeDetails = (data) => {
    setRole(data.group);
    openModal();
  };

  const addRole = () => {
    openModal();
    setRoleAdditionFlag(true);
  };

  return (
    <RoleTableWrapper width="100%">
      {error ? (
        <WrapperContainer
          Container={FlexContainers.FlexColumnCenter}
          width={"100%"}
          mt={50}
          textAlign={"center"}>
          <Paragraph2>{t(strCode.ERROR_FETCHING_GROUP_DATA_MESSAGE)}</Paragraph2>
        </WrapperContainer>
      ) : (
        <Table
          tooltipLabel={t(strCode.EDIT)}
          tableInstance={tableInstance}
          onRowClick={onSeeDetails}
          component={
            !isReadOnlyAccess && (
              <WrapperContainer
                Container={FlexContainers.FlexColumnCenter}
                gap={16}
                height={appGroupConfigs.length || isLoading ? 60 : 82}
                mt={appGroupConfigs.length || isLoading ? 0 : 24}>
                {!selectedApp?.groupConfigs?.length && !isLoading && (
                  <Paragraph2>{t(strCode.NO_ROLES_MESSAGE)}</Paragraph2>
                )}

                <CircleIconButton onClick={addRole}>
                  <SVG.PlusIcon />
                </CircleIconButton>
              </WrapperContainer>
            )
          }
          componentHeight={isReadOnlyAccess ? 0 : 60}
          maxTableHeight="186px"
          isLoading={isLoading}
          hasPagination
          showTableBorder
          modalTable
          modalTableSmall
          maxVisibleRows={1}
        />
      )}
    </RoleTableWrapper>
  );
};

RolesTabTable.propTypes = {
  openModal: PropTypes.func.isRequired,
  setRoleAdditionFlag: PropTypes.func.isRequired,
  setRole: PropTypes.func.isRequired,
  isReadOnlyAccess: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired
};

export default RolesTabTable;
